import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { InsuranceService } from '../../../../core/services/insurance.service';
import { AppState } from '../../../../store/app.state';
import { selectCurrentUser } from '../../../../store/auth/auth.selectors';

@Component({
  selector: 'app-message-responses',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-responses.component.html',
  styleUrls: ['./message-responses.component.scss'],
})
export class MessageResponsesComponent implements OnInit, OnDestroy {
  @Input() discussionId: string = '';
  @Input() messageId: string = '';

  responses: any[] = [];
  loading = false;
  currentUser: any = null;
  private subscription = new Subscription();

  constructor(
    private insuranceService: InsuranceService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    // Surveiller l'utilisateur courant
    this.subscription.add(
      this.store.select(selectCurrentUser).subscribe((user) => {
        this.currentUser = user;
      })
    );

    if (this.messageId) {
      this.loadResponses();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(): void {
    if (this.messageId) {
      this.loadResponses();
    }
  }

  loadResponses(): void {
    if (!this.messageId) return;

    this.loading = true;
    this.insuranceService.getMessageResponses(this.messageId).subscribe({
      next: (response) => {
        if (response && Array.isArray(response)) {
          this.responses = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.responses = response.data;
        } else {
          this.responses = [];
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading message responses:', error);
        this.responses = [];
        this.loading = false;
      },
    });
  }

  formatTimestamp(timestamp: string): string {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return date.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit',
      });
    } else if (diffInHours < 48) {
      return 'Hier';
    } else {
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
      });
    }
  }

  openDocument(document: any): void {
    if (document.url) {
      window.open(document.url, '_blank');
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  isOwnMessage(response: any): boolean {
    return !!response.senderId.startsWith('PM');
    // return (
    //   this.currentUser && response.senderId === this.currentUser.passportNumber
    // );
  }
}
